/* eslint-disable */
import React from 'react';
import { useGetApplication } from '~/controllers/wizard';
import { Stage } from '~/types/Application';
import { isAgent } from '~/utils/getDecodedJwt';
import AgentCompletedOnboarding from '~/pages/ksa/completion/completedOnboarding/agent';
import MerchantCompletedOnboarding from '~/pages/ksa/completion/completedOnboarding/merchant';
import ReviewReject from '~/pages/ksa/completion/reviewReject';
import Terminated from '~/pages/ksa/completion/terminated';
import Review from '~/pages/ksa/review';
import TechFailedOnboarding from '~/pages/ksa/completion/techFailedOnboarding/agent';
import MerchantOnboardingInProgress from '~/pages/ksa/completion/components/MerchantOnboardingInProgress';
import AgentAutomatedOnboarding from '~/pages/ksa/completion/automatedOnboarding/agent';
import AgentManualOnboarding from '~/pages/ksa/completion/manualOnboarding/agent';
import FailedOnboarding from '~/pages/ksa/completion/failedOnboarding/agent';

function AgentStatus(props: any) {
  const applicationQuery = useGetApplication();
  if (!applicationQuery.data) return null;

  const currentStage = applicationQuery.data.stage;

  switch (currentStage) {
    case Stage.ksaCompletedOnboarding:
      return <AgentCompletedOnboarding />;
    case Stage.ksaReviewReject:
      return <ReviewReject />;
    case Stage.ksaTerminated:
      return <Terminated />;
    case Stage.ksaTechFailedOnboarding:
      return <TechFailedOnboarding />;
    case Stage.ksaAutomatedOnboarding:
      return <AgentAutomatedOnboarding />;
    case Stage.ksaManualOnboarding:
      return <AgentManualOnboarding />;
    case Stage.ksaFailedOnboarding:
      return <FailedOnboarding />;
    default:
      return <></>;
  }

  return null;
}

export default AgentStatus;
